import React from 'react'

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import lightBlue from '@material-ui/core/colors/lightBlue';

import './filters.css'


import 'moment/locale/uk';
import moment from 'moment';
import Icon from "../../src/Icon";


/// THEME LIGHT

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiFormControl: {
      root: {
        padding: '0.5rem 0'
      },

    },
    MuiFormLabel: {
      root: {
        color: lightBlue['700']
      },
      /* focused: {
          color: lightBlue['900']
      } */
    },
    MuiInput: {
      root: {
        color: lightBlue['900'],
      },
      underline: {
        '&:after': {
          backgroundColor: lightBlue['400'],
          borderBottom: '2px solid #0072b47a'
        },
        '&:before': {
          backgroundColor: lightBlue['900'],
          height: '1px',
          borderBottom: '1px solid #0072b47a'

        },
        '&:hover': {
          '&:before': {
            backgroundColor: '#e3f5ff!important',
            borderBottom: '2px solid #2196F3!important'
          }
        }
      },

    },
    MuiMenuItem: {
      root: {
        color: '#fff!important',
      }
    },
    /*  MuiPaper: {
         root: {
             background: '#0288d1!important',
             color: '#fff!important',
         }
     }, */
    MuiSvgIcon: {
      root: {
        color: '#0072B4!important'
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: lightBlue[700]
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: '#ffffff',
        marginBottom: '0'
      },
      daysHeader: {
        backgroundColor: '#ffffff'
      }
    },

    MuiPickersDay: {
      day: {
        color: lightBlue.A700,
      },
      "&$selected": {
        backgroundColor: lightBlue['400'],
      },
      current: {
        color: lightBlue['900'],
      },
    },
    MuiPickersModal: {
      dialog: {
        backgroundColor: '#fff!important'
      },
      dialogActions: {
        backgroundColor: '#fff!important',
      },
      dialogAction: {

        color: lightBlue['400'],
      },
    },
    MuiList: {
      root: {
        background: lightBlue[700]
      }
    }
  },
});

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    // color: '#fff'

  },
  label: {
    // color: '#fff'
  },
  input: {
    // color: '#fff',
    border: 0,
    '& input': {
      borderBottom: 'none!important',
      margin: '0!important',
      boxShadow: 'none!important'
    }

  },
  button: {
    color: '#fff'
  },
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .30)',
  },

});



function Filters(props) {
  const { classes } = props;

  const listTechinics = () => {
    if (props.techlist === undefined) {
      return null
    }
    if (props.techlist.length === 0) {
      return null
    }
    return props.techlist.map((item) => {
      return <MenuItem value={item.id} key={item.id}> {item.name}</MenuItem>
    })
  }

  const listModel = () => {
    if (props.model === undefined) {
      return null
    }

    if (props.model.length === 0) {
      return null
    }
    return props.model.map((item) => {
      return <MenuItem value={item.id} key={item.id}> {item.name}</MenuItem>
    })
  }

  const listProducer = () => {
    if (!props.producer || !props.producer.length) {
      return null
    }
    return props.producer.map((item) => {
      return <MenuItem value={item.id} key={item.id}> {item.name}</MenuItem>
    })
  }
  const listStatus = () => {
    if (!props.listStatus || !props.listStatus.length) {
      return null
    }
    return props.listStatus.map((item) => {
      return <MenuItem value={item.id} key={item.id}> {item.name}</MenuItem>
    })
  }
  return (

    <div className="filter-block">
      <MuiThemeProvider theme={theme}>
        <FormControl fullWidth>
          <InputLabel htmlFor="filterTech" className={classes.input}>Тип техніки</InputLabel>
          <Select
            className={classes.input}
            value={props.valueType}
            onChange={props.selectType}
            input={<Input id="filterTech" />}
          >
            <MenuItem value=""></MenuItem>
            {listTechinics()}
          </Select>
        </FormControl>
      </MuiThemeProvider>

      <MuiThemeProvider theme={theme}>
        <FormControl fullWidth className={classes.input} disabled={props.disable_model}>
          <InputLabel className={classes.input} htmlFor="filterModel">Виберіть модель</InputLabel>
          <Select
            className={classes.input}
            value={props.valueModel}
            onChange={props.selectModel}
            input={<Input id="filterModel" />}
          >
            {(props.model.length === 0) ? <MenuItem value="" disabled>Немає результатів</MenuItem> : <MenuItem value="" disabled></MenuItem>}
            {listModel()}
          </Select>
        </FormControl>
      </MuiThemeProvider>

      <MuiThemeProvider theme={theme}>
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel htmlFor="filterProducer" className={classes.label}>Виробник
                        техніки</InputLabel>
          <Select
            className={classes.input}
            value={props.valueProducer}
            onChange={props.selectProducer}
            input={<Input id="filterProducer" />}
          >
            <MenuItem value=""></MenuItem>
            {listProducer()}
          </Select>
        </FormControl>
      </MuiThemeProvider>

      <MuiThemeProvider theme={theme}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel htmlFor="code-dep" className={classes.label}>Код підрозділу</InputLabel>
          <Input id="code-dep" className={classes.input} value={props.valueCode} onChange={props.handleChangeCode} />
        </FormControl>
      </MuiThemeProvider>
      <MuiThemeProvider theme={theme}>
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel className={classes.label} htmlFor="filterStatus">Статус заявки</InputLabel>
          <Select
            className={classes.input}
            value={props.valueStatus}
            onChange={props.statusSelect}
            input={<Input id="filterStatus" />}
          >
            <MenuItem value=""></MenuItem>
            {listStatus()}
          </Select>
        </FormControl>
      </MuiThemeProvider>

      <div className="datapicker">
        <Icon className='datapicker__icon'>event</Icon>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider
            utils={MomentUtils}
            moment={moment}
          >
            <DatePicker
              value={props.fromDate}
              onChange={props.changeFromDate}
              format='DD.MM.YYYY'
              label="Дата з"
              autoOk={true}
              clearable
              animateYearScrolling={false}
              clearLabel='Очистити'
              cancelLabel='Скасувати'
            />

          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </div>
      <div className="datapicker">
        <Icon className='datapicker__icon'>event</Icon>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider
            utils={MomentUtils}
            moment={moment}>
            <DatePicker
              className={classes.input}
              value={props.toDate}
              onChange={props.changeToDate}
              format='DD.MM.YYYY'
              label="Дата по"
              minDateMessage="Дата не повинна бути за дату 'Дату з' "
              minDate={props.fromDate}
              clearable
            />
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </div>

      <MuiThemeProvider theme={theme}>
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel className={classes.label} htmlFor="rangeTime">Період за</InputLabel>
          <Select
            className={classes.input}
            value={props.valueRange}
            onChange={props.handleRange}
            input={<Input id="rangeTime" />}
          >
            <MenuItem value=""></MenuItem>
            <MenuItem value={1}> Сьогодні</MenuItem>
            <MenuItem value={5}> Вчора</MenuItem>
            <MenuItem value={2}> 7 днів</MenuItem>
            <MenuItem value={3}> 1 місяць</MenuItem>
            <MenuItem value={4}> 1 рік</MenuItem>
          </Select>
        </FormControl>
      </MuiThemeProvider>

      <Button className={classes.button} fullWidth style={{ display: (props.clearFilterVal) ? 'inline-flex' : 'none' }}
        variant="contained" color="secondary"
        onClick={props.clearFilterAction}>
        Clear Filter
        <DeleteIcon className={classes.rightIcon} />
      </Button>
    </div>

  )
}

export default withStyles(styles)(Filters);


// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js